// src/pages/Programs.js
import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ProgramsCatalog from '../components/programs/ProgramsCatalog';

function Programs() {
  return (
    <>
      <Navbar />
      <ProgramsCatalog />
      <Footer />
    </>
  );
}

export default Programs;
